








































import IndicatorServices from '@/services/indicator';
import SubjectServices from '@/services/subject';
import IndicatorSetServices from '@/services/indicatorSet';
import RuleConditionItem from './rule-condition-item.vue';
import { Vue, Component, PropSync, Watch } from 'vue-property-decorator';
import { getSequence } from '@/libs/time';

@Component({
  components: { RuleConditionItem }
})
export default class RuleFormTab2Condition extends Vue {
  @PropSync('ruleDefinition') syncRuleList!: any;
  @PropSync('ruleDataCode') syncRuleDataCode!: any;
  @PropSync('ruleDataType') syncRuleDataType!: any;
  @PropSync('entity') syncEntity!: any;

  subjectSrv = new SubjectServices();
  indSrv = new IndicatorServices();
  indSetSrv = new IndicatorSetServices();
  code: any = [];

  created() {
    this.getSubList();
    this.getIndList();
  }

  changeCode(e: string[], reset: boolean = true) {
    let [type, code] = e;
    this.syncEntity.type = type;
    this.syncRuleDataType = type;
    this.syncRuleDataCode = code;
    this.getFieldList(type, code);
    // 重置所有规则
    reset && (this.syncRuleList.ruleConditionList = []);
  }

  fieldList: any[] = [];
  async getFieldList(type: string, code: string) {
    this.syncEntity.list = [];
    if (type == '0') {
      let list = await this.indSrv.getEnableList({ indSetCode_eq: code });
      this.fieldList = list.map((v: any) => ({
        label: v.indName,
        value: `${v.indCode}/${v.indDataFormat}/${v.indName}`
      }));
    }
    if (type == '1') {
      let list = await this.subjectSrv.getFieldList({ subCode_eq: code });
      this.fieldList = list.map((v: any) => {
        this.syncEntity.list.push({ label: v.fieldName, value: v.fieldCode });
        return {
          label: v.fieldName,
          value: `${v.fieldCode}/${v.fieldType}/${v.fieldName}`
        };
      });
    }
  }

  options = [
    { value: '1', label: '主题表', children: [] },
    { value: '0', label: '指标集', children: [] }
  ];

  async getSubList() {
    let list = await this.subjectSrv.getEnableList();
    this.options[0].children = list.map((v: any) => ({
      value: v.subCode,
      label: v.subName
    }));
  }

  async getIndList() {
    let list = await this.indSetSrv.getList();
    this.options[1].children = list.map((v: any) => ({
      value: v.indSetCode,
      label: v.indSetName
    }));
  }

  @Watch('syncRuleDataCode', { deep: true })
  onSyncRuleDataCodeChange() {
    if (this.syncRuleDataCode) {
      this.code = [this.syncRuleDataType?.toString(), this.syncRuleDataCode];
      this.changeCode(this.code, false);
    }
  }

  get logicalOperator() {
    return this.syncRuleList.logicalOperator;
  }

  set logicalOperator(value) {
    this.syncRuleList.logicalOperator = value;
  }

  get ruleConditionList() {
    return this.syncRuleList.ruleConditionList;
  }

  set ruleConditionList(value) {
    this.syncRuleList.ruleConditionList = value;
  }

  addRuleGroup() {
    if (this.code.length === 0) {
      this.$message.error('请先选择目标主题表或指标');
      return false;
    }
    this.ruleConditionList.push({
      groupName: '规则组名称',
      logicalOperator: '&&',
      ruleConditionList: [{ id: getSequence(), thresholdSetting: { range: 'rightOpen', threshold: { upper: '', lower: '' } } }]
    });
    this.refreshHeight();
  }

  addRule(index: number) {
    this.ruleConditionList[index].ruleConditionList.push({ id: getSequence(), thresholdSetting: { range: 'rightOpen', threshold: { upper: '', lower: '' } } });
    this.refreshHeight();
  }

  heightPercent: number = 1;
  refreshHeight() {
    setTimeout(() => {
      let dom: any = this.$refs.ruleGroupRef;
      let height: number = dom.offsetHeight;
      this.heightPercent = height;
    }, 100);
  }

  removeRuleGroup(index: number) {
    this.ruleConditionList.splice(index, 1);
    this.refreshHeight();
  }

  removeRule(groupIndex: number, ruleIndex: number) {
    this.ruleConditionList[groupIndex].ruleConditionList.splice(ruleIndex, 1);
    if (this.ruleConditionList[groupIndex].ruleConditionList.length === 0) {
      this.removeRuleGroup(groupIndex);
    }
    this.refreshHeight();
  }

  switchLogic() {
    this.logicalOperator = this.logicalOperator === '||' ? '&&' : '||';
  }

  getLogicClass(logic: string) {
    return logic === '||' ? 'l-warning' : 'l-success';
  }

  getLogicName(logic: string) {
    return logic === '||' ? '或' : '且';
  }
}
